import { PolicyService } from "@/types";

import { useMockContent } from "./content.shared";
import { apiPolicyProvider } from "./policy.api";
import { mockPolicyProvider } from "./policy.mock";

const policyProvider: PolicyService = useMockContent
  ? mockPolicyProvider
  : apiPolicyProvider;

export const policyService = policyProvider;
